import { Extension } from "@tiptap/core";

/** List looks that survive a round trip: the marker style rides as an inline
 *  `list-style-type` (so `01.` and `i.` render the same in the editor, on the
 *  page and in print), and `reversed` as the real HTML attribute. */
export const KbListAttributes = Extension.create({
  name: "kbListAttributes",

  addGlobalAttributes() {
    return [{
      types: ["orderedList", "bulletList"],
      attributes: {
        listStyle: {
          default: null,
          parseHTML: (el) => el.style?.listStyleType || null,
          renderHTML: (attrs) => (attrs.listStyle
            ? { style: `list-style-type: ${attrs.listStyle}` } : {}),
        },
        reversed: {
          default: null,
          parseHTML: (el) => (el.hasAttribute?.("reversed") ? true : null),
          renderHTML: (attrs) => (attrs.reversed ? { reversed: "reversed" } : {}),
        },
      },
    }];
  },
});
